import { qrsApi } from './config/delfarApi';
import { GetQrUrlsResponseDto } from './dto/qrs.dto';

export const getQrUrls = async (): Promise<GetQrUrlsResponseDto> =>
    qrsApi.get<GetQrUrlsResponseDto>('/me').then((r) => r.data);
